import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { AlarisEditPanelService, EditPanelInputData } from '@campaign-portal/components-library';
import { Role } from '@helpers/types/models';
import { RolesService } from '../roles.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-edit-role',
	templateUrl: './edit-role.component.html',
	styleUrl: './edit-role.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EditRoleComponent implements OnInit {
	readonly errors: { key: string; value: string }[] = [
		{key: 'mask', value: 'gl.errors.invalid_format'},
		{key: 'required', value: 'gl.errors.required'}];
	readonly role: Role = {
		ID: null,
		Name: '',
		Permissions: []
	};
	readonly roleForm = new FormGroup({
		name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
		permissions:  new FormControl<string[]>([], { nonNullable: true, validators: [Validators.required] })
	});
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(EditPanelInputData) private readonly inputData: { role?: Role },
		public readonly rolesService: RolesService,
		private readonly editPanel: AlarisEditPanelService
	) {
		if ( this.inputData.role ) {
			this.role = this.inputData.role;
		}
	}

	ngOnInit(): void {
		this.reset();
	}

	save(): void {
		const role: Role = {
			ID: this.role.ID,
			Name: this.roleForm.controls.name.value,
			Permissions: this.roleForm.controls.permissions.value
		};
		this.rolesService.update(role)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (Object.prototype.hasOwnProperty.call(resp, 'Updated')
					|| Object.prototype.hasOwnProperty.call(resp, 'Created')
				) {
					this.editPanel.close(true);
				}
			});
	}

	close(): void {
		this.editPanel.close(false);
	}

	reset(): void {
		const role = structuredClone(this.role);
		this.roleForm.reset({
			name: role.Name,
			permissions: role.Permissions
		});
	}

}
